<script setup>
import { useCookies } from '@vueuse/integrations/useCookies';
import { computed, ref } from "vue";

// https://vueuse.org/integrations/useCookies/
const { set: setCookie, get: getCookie } = useCookies();

const cookieShown = ref(false);

const isCookieConfirmed = computed(() => {
    return getCookie('cookieConfirmed') ?? false;
});

checkCookie();

function checkCookie() {
    if (!isCookieConfirmed.value) {
        setTimeout(() => {
            cookieShown.value = true;
        }, 2000);
    }
}

function onConfirmCookie() {
    setCookie('cookieConfirmed', true, {
        path: '/',
        expires: new Date(Date.now() + 2592000000),
    });
    cookieShown.value = false;
}
</script>

<template>
    <div
        v-if="cookieShown"
        id="notification"
        class="notification-cookie"
        :class="{ 'shown': cookieShown }"
    >
        <div class="notification-cookie__text">
            Мы используем файлы cookie для вашего удобства пользования сайтом.
            <a href="/customer/privacy-and-policy/"> Больше о cookie</a>
        </div>
        <button
            class="btn"
            @click="onConfirmCookie"
            data-notification-close
        >
            Понятно
        </button>
    </div>
</template>
